module.exports = __webpack_public_path__ + "__static/site-1784740481084/img/chicken.b7ce141c.png";